module.exports = __webpack_public_path__ + "static/obvious_5-325f8cb187832b09733ccf7ebfe0581d.jpg";